import { render } from "./BannerNotificationContainer.vue?vue&type=template&id=1260e1ba&scoped=true&ts=true"
import script from "./BannerNotificationContainer.vue?vue&type=script&lang=ts"
export * from "./BannerNotificationContainer.vue?vue&type=script&lang=ts"

import "./BannerNotificationContainer.vue?vue&type=style&index=0&id=1260e1ba&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1260e1ba"]])

export default __exports__